import Parameters from './Parameters/Parameters';
import Items from './Items/Items';
import TagGroups from './TagGroups/TagGroups';
import Users from './Users/Users';
import Profiles from './Profiles/Profiles';
import ItemGroups from './ItemGroups/ItemGroups';
import History from './History/History';
import { USER_ROLE } from 'src/services/user/types';

export interface ISubPage {
  path: string;
  name: string;
  component: any;
  authorizedRoles: USER_ROLE[];
}

export const subPages: ISubPage[] = [
  {
    path: '/admin/parameters',
    name: 'Parameters',
    component: Parameters,
    authorizedRoles: ['SuperAdmin', 'ContentAdmin'], // , 'LocalContentAdmin'
  },
  {
    path: '/admin/items',
    name: 'Items',
    component: Items,
    authorizedRoles: ['SuperAdmin', 'ContentAdmin', 'LocalContentAdmin'],
  },
  {
    path: '/admin/item-groups',
    name: 'Item Groups',
    component: ItemGroups,
    authorizedRoles: ['SuperAdmin', 'ContentAdmin'],
  },
  {
    path: '/admin/tag-groups',
    name: 'Tag Groups',
    component: TagGroups,
    authorizedRoles: ['SuperAdmin', 'ContentAdmin'], // , 'LocalContentAdmin'
  },
  {
    path: '/admin/users',
    name: 'Users',
    component: Users,
    authorizedRoles: ['SuperAdmin', 'UserAdmin', 'LocalUserAdmin'],
  },
  {
    path: '/admin/profiles',
    name: 'Profiles',
    component: Profiles,
    authorizedRoles: ['SuperAdmin'],
  },
  {
    path: '/admin/history',
    name: 'History',
    component: History,
    authorizedRoles: ['SuperAdmin'],
  },
];



// WEBPACK FOOTER //
// ./src/views/Admin/index.ts